/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import NotAuthorised from './not-authorised';
import Header from '@features/header';
import { LoginCallback } from '@okta/okta-react';
import { Loader } from '@g17eco/atoms/loader';
import { Button } from 'reactstrap';
import { useAppDispatch } from '../reducers';
import { logout } from '../actions/auth';

interface Error {
  name: string;
  errorCode?: string;
  errorSummary?: string
}

const CustomLoginCallback = () => {
  const history = useHistory();

  const dispatch = useAppDispatch();
  const handleLogout = () => dispatch(logout('/'));

  const getMessage = (error?: Error) => {
    if (!error) {
      return 'Something went wrong';
    }

    const { errorCode, errorSummary } = error;
    if (errorCode === 'access_denied') {
      return <>
        You do not have permission to access the platform. Please contact G17Eco support or
        <Button size='sm' color='link' onClick={handleLogout}>click here to logout</Button>
      </>;
    }
    return errorSummary;
  }

  const renderError = (props?: { error?: Error }) => {
    return <>
      <Route path='/:root?/:unused?' component={Header} />
      <div className='main-container'>
        <NotAuthorised message={
          <>
            <i className='fa fa-exclamation-triangle mr-2' />{getMessage(props?.error)}
          </>
        } />
      </div>
    </>;
  };

  if (!history.location.search) {
    return renderError();
  }

  return <LoginCallback
    errorComponent={renderError}
    loadingElement={<Loader />}
  />;
}

export default CustomLoginCallback;
